<template>
    <div class="home-container">
      <div class="d-flex flex-column align-items-center justify-content-center gap-3">
        <h5 class="extra-large-text">დაამატეთ ქალაქი</h5>
        <form class="add-form modal-form-grid-wrapper p-4 border-radius-10" @submit.prevent="addCities">
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="cityName" class="ms-2">ქალაქის სახელი(ქართულად)</label>
            <input v-model="cityDataVModels.city" pattern="[\u10A0-\u10FF\d !@#$^&\(\)\/*.+,_:?\-\\]+" type="text" autocomplete="off" name="cityName" id="cityName" required placeholder="ქალაქის სახელი(ქართულად)" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
            <label for="cityengName" class="ms-2">(ინგლისურად)ქალაქის სახელი</label>
            <input v-model="cityDataVModels.cityeng" pattern="[A-Za-z\d !@#$^&\(\)\/*.+,_:?\-\\]+" type="text" autocomplete="off" name="cityengName" id="cityengName" required placeholder="(ინგლისურად)ქალაქის სახელი" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="municipalityID" id="municipalityID-assist" class="ms-2">მონიშნეთ მუნიციპალიტეტი</label>
            <Multiselect v-for="(data, i) of multiselectArray" name="municipalityID" id="municipalityID" v-model="cityDataVModels.municipalityID" :options="data.options" :mode="data.mode"
                :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" :required="true"
                class="extra-light-text light-blue-color" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
          </fieldset>
          <div class="button-wrapper d-flex justify-content-center w-100">
            <secondaryButton :disabled="isSending" buttonWidth="max-content" buttonType="submit" class="large-text mt-4">
                <template v-slot:content>
                    დამატება
                </template>
            </secondaryButton>
          </div>
        </form>
        
        <div class="w-100">
            <polygonMapComponent @updatePolygon="updatePolygon" maxHeight="700px"/>
        </div>
      </div>
    </div>
</template>
<script>
import secondaryButton from "@/components/secondaryButton.vue"
import primaryButtonComponent from "@/components/primaryButtonComponent.vue";
import polygonMapComponent from "@/components/polygonMapComponent.vue";
import Multiselect from '@vueform/multiselect';
export default {
  data(){
    return {
      cityDataVModels: {
        city: "",
        cityeng: "",
        municipalityID: null,
        polygons: [],
      },
      polygon: null,
      multiselectArray: [
        {
          placeholder: "მუნიციპალიტეტი",
          options: [],
          Vmodel: null,
          mode: "single",
          isDisabled: false,
        },
      ],
      isSending: false,
    }
  },
  components: {
    secondaryButton,
    primaryButtonComponent,
    polygonMapComponent,
    Multiselect,
  },
  mounted(){
    this.getMunicipalities();
  },
  methods: {
    getMunicipalities(){
        this.$store.dispatch("getMunicipalities").then((response) => {
            
          let tempArray = [];
          for(let municipality of response.data){
              tempArray.push({
                  value: municipality.municipalityID,
                  label: {
                      ge: municipality.municipality,
                      en: municipality.municipalityeng,
                  },
              });
          }
          
          this.multiselectArray[0].options = tempArray;
            
        })
    },
    updatePolygon(newPolygon){
        if(newPolygon == null){
            this.cityDataVModels.polygons = [];
        }
        this.polygon = newPolygon;
    },
    addCities(){
        let iscityValid = this.$helper.checkString(this.cityDataVModels.city);
        let isEngCityValid = this.$helper.checkEngString(this.cityDataVModels.cityeng);
        this.cityDataVModels.polygons = [];
        let path = [];
        if(this.polygon != null){
            path = this.polygon.getPath();
            path.forEach((latLng, index) => {
                this.cityDataVModels.polygons.push({
                    lat: latLng.lat(),
                    lng: latLng.lng(),
                });
            });

        }
        

        if(iscityValid && isEngCityValid && this.cityDataVModels.polygons.length > 0){
          this.isSending = true;
            this.$store.dispatch("addCities", this.cityDataVModels).then((response) => {
            if(response.status == 201){
                this.$helper.showSwal("ქალაქი წარმატებით დაემატა", "success", "");
                setTimeout(() => {this.$router.go()}, 1500);
            }
            }).catch((error) => {
                if(error?.response?.status == 422){
                    this.$helper.showSwal("მოხდა შეცდომა", "error", "");
                    setTimeout(() => {this.$router.go()}, 1500);
                }
            }).finally(() => {
              this.isSending = false;
            })
        }
    }
  }
}
</script>
<style scoped>
input[type="checkbox"]{
    width: 30px;
    height: 30px;
    cursor: pointer;
}
.home-container{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, min-content);
  row-gap: 1.5em;
}
.add-form{
  background-color: var(--secondary-background-color);
  width: 60%;
}
.modal-form-grid-wrapper{
  /* width: 100%; */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 1em;
  row-gap: 2em;
}
.modal-form-grid-wrapper .blue-part-input{
  padding-block: 15px;
  max-width: 400px;
}
.button-wrapper{
  grid-column: 1/3;
}
textarea.blue-part-input{
  width: 100%;
  resize: none;
}
.multiselect{
    --ms-placeholder-color: var(--light-blue);
    --ms-tag-bg: var(--light-blue);
    --ms-option-bg-selected: var(--light-blue);
    --ms-option-bg-selected-pointed: var(--light-blue);
    flex: 1;
    max-width: 235px;
    margin: 0;
}
#map{
    height: 500px;
    width: 100%;
}

@media screen and (max-width: 1800px) {
  .add-form{
    width: 70%;
  }
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 3em;
  }
}

@media screen and (max-width: 1560px) {
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 2em;
  }
  .modal-form-grid-wrapper .blue-part-input{
    padding: 10px;
  }
}
@media screen and (max-width: 1200px) {
  .add-form{
    width: 90%;
  }
}
</style>
